import Client from '@/clients/base';
import { BaseEntity } from '@/entities/entity';
import BaseService from './base.service';
// export class WwxBaseService<E,I,C,F> extends BaseService
export class PhysicalBaseService<E extends BaseEntity, I, C, F> extends BaseService<E, I, C, F> {
    constructor(path: string) {
        super(path, Client);
    }
}
